import { render, staticRenderFns } from "./ModalSubUsers.vue?vue&type=template&id=2d37cae8&scoped=true&"
import script from "./ModalSubUsers.vue?vue&type=script&lang=js&"
export * from "./ModalSubUsers.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubUsers.vue?vue&type=style&index=0&id=2d37cae8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d37cae8",
  null
  
)

export default component.exports